import useParameterValue from '@/services/data/hooks/useParameterValue.ts'
import { IEquipment } from '@/pages/Equipment/equipment.types.ts'
import TextStatisticCard from '@/shared/Analytics/TextStatisticCard'
import cn from '@/utils/cn.ts'

interface IProps {
  equipmentId: IEquipment['id']
  title: string
}

const LiftModeCard = (props: IProps) => {
  const mode = useParameterValue(props.equipmentId, 'modeToggleSwitchPosition')

  const getValue = () => {
    if (mode.loading) return ''

    switch (mode.value) {
      case 0:
        return '—'
      case 1:
        return 'Погруз'
      case 2:
        return 'Нормальная работа'
      case 3:
        return 'Ревизия'
      case 4:
        return 'МП1'
      case 5:
        return 'МП2'
      default:
        return '—'
    }
  }

  return (
    <TextStatisticCard title={props.title} loading={mode.loading} width="100%" height="84px">
      <p
        className={cn({
          'text-heading-5': true,
          'text-warning': mode.value !== 0 && mode.value !== 2,
          'text-success': mode.value === 2,
        })}
      >
        {getValue()}
      </p>
    </TextStatisticCard>
  )
}

export default LiftModeCard
